import React, { Component } from 'react';
import { connect } from 'react-redux';
import Portal from '../../Helpers/Portal';
import { VelocityTransitionGroup  } from 'velocity-react';
import uid from '../../../utils/generateUid';
import webp from '../../../utils/webp';
import { observer, inject } from "mobx-react";
import Aspect from "../Aspect";
import LazyImg from "../LazyImg";
import LazyBg from "../LazyBg";

class GridGallery extends Component {
  constructor(props) {
    super(props);
    this.state= {
      show_popup: false,
      big_sizes: null,
      win_width:0,
      win_height:0,
      uid:uid(),
      resize:'',
      sdvig:{ x:0, y:0 }
    };
    this._touchStart=(e)=>{

      if(e.target.className.indexOf('bigImage')>0) {
        e.preventDefault();
        e.stopPropagation();
        this._touchStartData = {
          x: e.touches[0].clientX,
          y: e.touches[0].clientY,
          target: e.target,
        };
        e.target.className+=' blockTransition';
      } else {
        this._touchStartData=false;
      }

      console.log('_touchStart',this._touchStart);
    };
    this._touchMove=(e)=>{
      if(this._touchStartData) {
        e.preventDefault();
        e.stopPropagation();
        this._lastTouchDelta = {
          x: e.touches[0].clientX - this._touchStartData.x,
          y: e.touches[0].clientY - this._touchStartData.y,
        };

        if (Math.abs(this._lastTouchDelta.x) > 5 || Math.abs(this._lastTouchDelta.y) > 5) {
          if (Math.abs(this._lastTouchDelta.x) > Math.abs(this._lastTouchDelta.y)) {
            this._touchStartData.target.style.marginTop='0px';
            this._touchStartData.target.style.marginLeft = this._lastTouchDelta.x + 'px';
          } else {
            this._touchStartData.target.style.marginTop = this._lastTouchDelta.y + 'px';
            this._touchStartData.target.style.marginLeft='0px';
          }
        }
      }
    };
    this._touchEnd=(e)=>{
      if(this._touchStartData) {
        e.returnValue = false;
        e.cancelBubble = true;
        e.preventDefault();
        e.stopPropagation();
        let ret = false;
        if (Math.abs(this._lastTouchDelta.x) > 50 || Math.abs(this._lastTouchDelta.y) > 50) {
          if (Math.abs(this._lastTouchDelta.x) > Math.abs(this._lastTouchDelta.y)) {
            if (this._lastTouchDelta.x > 0) {
              ret = this.movePrev();
            } else {
              ret = this.moveNext();
            }
          } else {
            ret=true;
            this.setState({show_popup: false});
          }
        } else {
          //moveBack
        }

        if (!ret) {
          this._touchStartData.target.className=this._touchStartData.target.className.replace('blockTransition','');;
          this._touchStartData.target.style.marginTop = 0;
          this._touchStartData.target.style.marginLeft = 0;
        }

        this._lastTouchDelta = {x: 0, y: 0};
        this._touchStartData = false;
        console.log('_touchEnd', this._lastTouchDelta);
      }
    };
    this._onResize=()=>{
      setTimeout(()=>{
        let state={ resize:this.getResizeCode(), win_width: window.innerWidth, win_height:window.innerHeight };

        if(this._bigImageRef) {
          state.big_sizes={width:this._bigImageRef.clientWidth, height:this._bigImageRef.clientHeight};
        }
        this.setState(state);
      },100);
    };
    this._onWheel=(e)=>{
      let next=e.deltaY>0;
      if(next) {
        this.moveNext();
      } else {
        this.movePrev();
      }
      console.log('onWheel',e.deltaY);

    };
    this._onKey=(e)=>{
      switch(e.which) {
        case 37: //left
          this.movePrev();
          break;
        case 39: //right
          this.moveNext();
          break;
        case 27: //right
          this.setState({ show_popup:false, big_sizes:null });
          break;
      }
      console.log('keypress',e);
    }
  }
  movePrev() {
    if (this.props.items[this.state.show_popup - 1]) {
      this.setState({show_popup: this.state.show_popup - 1, big_sizes: null, uid: uid()});
      return true;
    }
    return false;
  }
  moveNext() {
    if(this.props.items[this.state.show_popup+1]) {
      this.setState({ show_popup: this.state.show_popup + 1,big_sizes:null,uid:uid() });
      return true;
    }
    return false;
  }
  renderList() {
    if(this.props.items && this.props.items.length) {
      let img, img0, img1, img2, img3, img4;
      switch(this.props.listMode) {
        case "chat":
          switch (this.props.items.length) {
            case 1:
                img=this.props.items[0];
                return (
                  <Aspect pa={true} className="bg-w2" img={img} resizedCode={"600x600"}>
                    <a onClick={(e)=>{ e.preventDefault(); }} href={img[this.props.index]}>
                      <LazyImg
                        hiddenClassName="w100 h100"
                        passProps={{
                          onClick: ()=>{ this.setState({ show_popup:0,big_sizes:null,uid:uid() }) },
                          onLoad: ()=>{ if(this.props.onListImgLoad) { this.props.onListImgLoad(); } },
                        }}
                        src={webp(this,`/autoresize/600x600${img[this.props.index]}`)}
                        className="db mw100 rad4 pointer"
                      />
                    </a>
                  </Aspect>
                );
              break;
            case 2:
              img0=this.props.items[0];
              img1=this.props.items[1];
              return (
                <div className="up12-superSmall">
                  <div className="up12 margin">
                    <div className="cell s-6">
                      <Aspect pa={true} className="bg-w2" aspect="400:300">
                        <LazyImg
                          hiddenClassName="w100 h100"
                          passProps={{
                            onClick: ()=>{ this.setState({ show_popup:0,big_sizes:null,uid:uid() }) },
                            onLoad: ()=>{ if(this.props.onListImgLoad) { this.props.onListImgLoad(); } }
                          }}
                          src={webp(this,`/autoresize/300x400xC${img0[this.props.index]}`)}
                          className="db mw100 rad4-tl rad4-bl pointer"
                        />
                      </Aspect>
                    </div>
                    <div className="cell s-6">
                      <Aspect pa={true} className="bg-w2" aspect="400:300">
                        <LazyImg
                          hiddenClassName="w100 h100"
                          passProps={{
                            onClick: ()=>{ this.setState({ show_popup:1,big_sizes:null,uid:uid() }) },
                            onLoad: ()=>{ if(this.props.onListImgLoad) { this.props.onListImgLoad(); } }
                          }}
                          src={webp(this,`/autoresize/300x400xC${img1[this.props.index]}`)}
                          className="db mw100 rad4-tr rad4-br pointer"
                        />
                      </Aspect>
                    </div>
                  </div>
                </div>
              );
              break;

            case 3:
              img0=this.props.items[0];
              img1=this.props.items[1];
              img2=this.props.items[2];
              return (
                <div className="up12-superSmall">
                  <div className="up12 margin">
                    <div className="cell s-12">
                      <Aspect pa={true} className="bg-w2" aspect="400:600">
                        <LazyImg
                          hiddenClassName="w100 h100"
                          passProps={{
                            onClick: ()=>{ this.setState({ show_popup:0,big_sizes:null,uid:uid() }) },
                            onLoad: ()=>{ if(this.props.onListImgLoad) { this.props.onListImgLoad(); } },
                          }}
                          src={webp(this,`/autoresize/600x400xC${img0[this.props.index]}`)}
                          className="db mw100 rad4-tl rad4-tr pointer"
                        />
                      </Aspect>
                    </div>
                    <div className="cell s-6 ptop4">
                      <Aspect pa={true} className="bg-w2" aspect="200:300">
                        <LazyImg
                          hiddenClassName="w100 h100"
                          passProps={{
                            onClick: ()=>{ this.setState({ show_popup:1,big_sizes:null,uid:uid() }) },
                            onLoad: ()=>{ if(this.props.onListImgLoad) { this.props.onListImgLoad(); } }
                          }}
                          src={webp(this,`/autoresize/300x200xC${img1[this.props.index]}`)}
                          className="db mw100 rad4-bl pointer"
                        />
                      </Aspect>
                    </div>
                    <div className="cell s-6 ptop4">
                      <Aspect pa={true} className="bg-w2" aspect="200:300">
                        <LazyImg
                          hiddenClassName="w100 h100"
                          passProps={{
                            onClick: ()=>{ this.setState({ show_popup:2,big_sizes:null,uid:uid() }) },
                            onLoad: ()=>{ if(this.props.onListImgLoad) { this.props.onListImgLoad(); } },
                          }}
                          src={webp(this,`/autoresize/300x200xC${img2[this.props.index]}`)}
                          className="db mw100 rad4-br pointer"
                        />
                      </Aspect>
                    </div>
                  </div>
                </div>
              );
              break;
            default:
              img0=this.props.items[0];
              img1=this.props.items[1];
              img2=this.props.items[2];
              img3=this.props.items[3];
              img4=this.props.items[4];
              const countNumPlus=this.props.items.length-4;
              return (
                <div className="up12-superSmall">
                  <div className="up12 margin">
                    <div className="cell s-12">
                      <Aspect pa={true} className="bg-w2" aspect="400:600">
                        <LazyImg
                          hiddenClassName="w100 h100"
                          passProps={{
                            onClick: ()=>{ this.setState({ show_popup:0,big_sizes:null,uid:uid() }) },
                            onLoad: ()=>{ if(this.props.onListImgLoad) { this.props.onListImgLoad(); } },
                          }}
                          src={webp(this,`/autoresize/600x400xC${img0[this.props.index]}`)}
                          className="db mw100 rad4-tl rad4-tr pointer"
                        />
                      </Aspect>
                    </div>
                    <div className="cell s-4 mtop4">
                      <Aspect pa={true} className="bg-w2" aspect="200:300">
                        <LazyImg
                          hiddenClassName="w100 h100"
                          passProps={{
                            onClick: ()=>{ this.setState({ show_popup:1,big_sizes:null,uid:uid() }) },
                            onLoad: ()=>{ if(this.props.onListImgLoad) { this.props.onListImgLoad(); } },
                          }}
                          src={webp(this,`/autoresize/300x200xC${img1[this.props.index]}`)}
                          className="db mw100 rad4-bl pointer"
                        />
                      </Aspect>
                    </div>
                    <div className="cell s-4 mtop4">
                      <Aspect pa={true} className="bg-w2" aspect="200:300">
                        <LazyImg
                          hiddenClassName="w100 h100"
                          passProps={{
                            onClick: ()=>{ this.setState({ show_popup:2,big_sizes:null,uid:uid() }) },
                            onLoad: ()=>{ if(this.props.onListImgLoad) { this.props.onListImgLoad(); } },
                          }}
                          src={webp(this,`/autoresize/300x200xC${img2[this.props.index]}`)}
                          className="db mw100 pointer"
                        />
                      </Aspect>
                    </div>
                    <div className="cell s-4 mtop4 pr">
                      <Aspect pa={true} className="bg-w2" aspect="200:300">
                        <LazyImg
                          hiddenClassName="w100 h100"
                          passProps={{
                            onClick: ()=>{ this.setState({ show_popup:3,big_sizes:null,uid:uid() }) },
                            onLoad: ()=>{ if(this.props.onListImgLoad) { this.props.onListImgLoad(); } },
                          }}
                          src={webp(this,`/autoresize/300x200xC${img3[this.props.index]}`)}
                          className="db mw100 rad4-br pointer"
                        />
                      </Aspect>
                      {countNumPlus>0?(
                        <div className="pa pa-tl w100 h100 bg-b1-op50 w1 pointer" onClick={()=>{ this.setState({ show_popup:3,big_sizes:null,uid:uid() }) }}>
                          <div className="up12 splice h100">
                            <div className="cell s-12 s-middle tac fs30">
                              + {countNumPlus}
                            </div>
                          </div>
                        </div>
                      ):null}
                    </div>
                  </div>
                </div>
              );
              break;
          }
          break;
        case "grid":
          const images=this.props.items.map((item,index)=>{
            return (
              <div key={index} className="cell mbottom15" onClick={()=>{ this.setState({ show_popup: index, big_sizes:null, uid:uid() }) }}>
                <Aspect className="pr" img={this.props.items[0]}>
                  <a onClick={(e)=>{ e.preventDefault(); }} href={item.path}>
                    <LazyBg className="pa pa-tl bg-w2 rad4 ofh pointer w100 h100" style={{backgroundPosition:'center center',backgroundSize:'contain', backgroundRepeat:'no-repeat',backgroundImage:`url('/autoresize/300x0${item.path}')`}} />
                  </a>
                </Aspect>
              </div>
            )
          });
          return (
            <div className={`up12 margin s-size-${this.props.in_line || 5}`}>
              {images}
            </div>
          )
        default:
          const list=this.props.items.map((item,index)=>{
            if(!index && this.props.first) {
              return (
                <div key={item[this.props.index]}>
                  <span className="db mw100 pointer vat m-padd5 bg-w1" onClick={()=>{ this.setState({ show_popup:index,big_sizes:null,uid:uid() }) }}>
                    <img src={webp(this,`/autoresize/${this.props.first}${item[this.props.index]}`)} className="db mw100 gridImageFirst" />
                  </span>
                </div>
              )
            }
            return (
              <span key={item[this.props.index]} className="dib pointer vat m-padd5 bg-w1" onClick={()=>{ this.setState({ show_popup:index,big_sizes:null,uid:uid() }) }}>
                <img src={webp(this,`/autoresize/${this.props.autoresize?this.props.autoresize:'0x150'}${item[this.props.index]}`)} className="db gridImage" />
              </span>
            )
          });
          return (
            <div className="only-s-wsnw only-s-ofa">
              {list}
            </div>
          )
      }
    }
  }
  componentWillUnmount() {
    window.removeEventListener('resize',this._onResize);
    this.unbindAll();
  }
  unbindAll() {
    window.removeEventListener('resize',this._onResize);

    window.removeEventListener('keydown',this._onKey);
    window.removeEventListener("wheel", this._onWheel);

    window.removeEventListener("touchstart", this._touchStart);
    window.removeEventListener("touchmove", this._touchMove);
    window.removeEventListener("touchend", this._touchEnd);
    setTimeout(()=>{
      document.getElementsByTagName("body")[0].style.overflow='auto';
    },300);
  }
  componentDidUpdate(oldProps,oldState) {
    if(this.state.show_popup===false && oldState.show_popup!==false ||
      this.state.show_popup!==false && oldState.show_popup===false) {
      if(this.state.show_popup !== false ) {
        window.addEventListener('resize',this._onResize);
        document.getElementsByTagName("body")[0].style.overflow='hidden';
        window.addEventListener('keydown',this._onKey);
        window.addEventListener("wheel", this._onWheel);

        console.log('this._imageWrapRef',this._imageWrapRef);

          window.addEventListener("touchstart", this._touchStart);
          window.addEventListener("touchmove", this._touchMove);
          window.addEventListener("touchend", this._touchEnd);


        this._onResize();
      } else {
        this.unbindAll();
      }
    }
  }
  bigImageLoaded(e) {
    let target=e.target;
    setTimeout(()=> {
      this.setState({big_sizes: {width: target.clientWidth, height: target.clientHeight}});
      console.log('bigImageLoaded',{big_sizes: {width: target.clientWidth, height: target.clientHeight}});
    },100);
  }
  miniImageLoaded(e) {
    console.log('miniImageLoaded',e.target.clientWidth,e.target.clientHeight);
  }
  renderLine() {
    if(this.state.show_popup!==false) {
      if(this.props.items.length<=1) {
        return null;
      }
      const smallImgs=this.props.items.map((item,index)=>{
        return (
          <div  key={`smallimg${index}`} className="dib pr pointer" onClick={()=>{ this.setState({ show_popup:index,big_sizes:null,uid:uid() }) }}>
            <img onLoad={(e)=>{ this.miniImageLoaded(e); }} src={webp(this,`/autoresize/0x80${item[this.props.index]}`)} className={`db ${this.state.show_popup===index?'':'op50'} `} />
            <VelocityTransitionGroup enter={{animation: "fadeIn"}} leave={{animation: "fadeOut"}}>
              {this.state.show_popup===index?<div key={`selector${index}${uid()}`} className="solid3 trans03 bo-w1 w100 h100 pa pa-tl"></div>:undefined}
            </VelocityTransitionGroup>
          </div>
        )
      });
      return (
        <div style={{zIndex:10200 ,overflow:'scroll', height:105, whiteSpace:'nowrap', bottom:-25, width:'calc(100% + 25px)'}} className="tac w100 wsnw pf pa-bl bg-b1">
          {smallImgs}
        </div>
      )
    }
  }
  mainImageClick() {
    this.moveNext();
  }
  haveNext() {
    return this.props.items[this.state.show_popup+1]?true:false;
  }
  havePrev() {
    return this.props.items[this.state.show_popup-1]?true:false;
  }
  renderControlls() {
    if(this.state.show_popup === false) {
      return null;
    }

    return (
      <>
        <div onClick={()=>{ this.setState({ show_popup:false,big_sizes:null,uid:uid() }); }} className="pointer pf pa-tr w1" style={{zIndex:10300}}>
          <span className="mdi mdi-close fs40"></span>
        </div>
        {this.havePrev()?(
          <div onClick={()=>{ this.movePrev(); }} className="pointer pf pa-tl w1 h100 only-s-dn" style={{zIndex:10200}}>
            <div className="up12 h100 splice bg-w1-op70-hover trans03" style={{width: 40}}>
              <div className="s-auto cell s-middle tac mdi mdi-chevron-left fs40"></div>
            </div>
          </div>
        ):null}

        {this.haveNext()?(
          <div onClick={()=>{ this.moveNext(); }} className="pointer pf pa-tr w1 h100 only-s-dn" style={{zIndex:10200}}>
            <div className="up12 h100 splice bg-w1-op70-hover trans03" style={{width: 40}}>
              <div className="s-auto cell s-middle tac mdi mdi-chevron-right fs40"></div>
            </div>
          </div>
        ):null}
      </>
    )
  }
  renderPopup() {
      return (
        <Portal>
          <div className="gridGallery">
            <VelocityTransitionGroup enter={{animation: "fadeIn"}} leave={{animation: "fadeOut"}}>
              {this.state.show_popup!==false ? (
                <div onClick={()=>{ this.setState({ show_popup:false,big_sizes:null,uid:uid() }); }} className="pf pa-tl w100 h100 bg-b1-op20" style={{zIndex:10200-1}}></div>
              ) : undefined}
            </VelocityTransitionGroup>
            <span onClick={()=>{ this.mainImageClick(); }} ref={(ref)=>{ this._imageWrapRef=ref; }}>
              <VelocityTransitionGroup  enter={{animation: "fadeIn"}} leave={{animation: "fadeOut"}}>
                {this.state.show_popup!==false ? (
                  <div key={`img${this.state.show_popup}${this.state.uid}`} className="pf" style={{...this.getImgStyle(), zIndex:10200 }}>
                    <img onLoad={(e)=>{ this.bigImageLoaded(e); }}  src={`${this.state.resize}${this.props.items[this.state.show_popup][this.props.index]}`} style={{...this.getMwMh()}} className={`db bigImage trans03 ${this.state.big_sizes?'':'op0'}`}  />
                  </div>
                ) : undefined}
              </VelocityTransitionGroup>
            </span>
            <VelocityTransitionGroup enter={{animation: "fadeIn"}} leave={{animation: "fadeOut"}}>
              {this.renderLine()}
            </VelocityTransitionGroup>
          </div>
          {this.renderControlls()}
        </Portal>
      )
  }
  getMwMh()
  {
    let ob={};
    /*let innerWidth=this.state.win_width;//window.innerWidth;
    let innerHeight=this.state.win_height;//indow.innerHeight;*/

    let innerWidth=window.innerWidth;
    let innerHeight=window.innerHeight;

    ob.maxWidth = innerWidth;
    if(innerWidth>=768) {
      ob.maxWidth=innerWidth-60;
    }
    if(innerWidth>=1024) {
      ob.maxWidth = innerWidth - 80;
    }
    if(ob.maxWidth>1200) {
      ob.maxWidth=1200;
    }
    ob.maxHeight=innerHeight;
    if(this.props.items.length>1) { //is line
      ob.maxHeight-=80;
    }

    return ob;
  }
  getImgStyle() {
    let ob={};
    const innerWidth=this.state.win_width;//window.innerWidth;
    const innerHeight=this.state.win_height;//indow.innerHeight;
    /*const innerWidth=window.innerWidth;
    const innerHeight=window.innerHeight;*/
    /*ob.maxWidth = innerWidth;
    if(innerWidth>=768) {
      ob.maxWidth=innerWidth-60;
    }
    if(innerWidth>=1024) {
      ob.maxWidth = innerWidth - 80;
    }
    if(ob.maxWidth>1200) {
      ob.maxWidth=1200;
    }
    ob.maxHeight=innerHeight-40;*/

    if(this.state.big_sizes) {
      const mh=this.getMwMh();
      ob.top=mh.maxHeight/2-this.state.big_sizes.height/2;
      ob.left=innerWidth/2-this.state.big_sizes.width/2;

      ob.width=this.state.big_sizes.width;
      ob.height=this.state.big_sizes.height;
      console.log('obbbb',ob,this.state.big_sizes.height,{ maxheight:mh.maxHeight,height:this.state.big_sizes.height } );
    } else {
      ob.top=0;
      ob.left=0;
    }

    console.log('max',ob);
    return ob;
  }
  getResizeCode() {
     let sSravn=0;
     let sravn=0;

     const width=window.innerWidth;
     const height=window.innerHeight;

     if(height<width)
       sSravn=height;
     else
       sSravn=width;

     let stupeni=[700,1000,1500];

     for(var i in stupeni)
     {
       if(sSravn<stupeni[i])
       {
         sravn=stupeni[i];
         break;
       }
     }
     if(sravn==0) {
       sravn=1500;
     }

     if(sSravn==height) {
       return `/autoresize/0x${sravn}`;
     } else {
       return `/autoresize/${sravn}x0`;
     }
   }
  render() {
    return (
      <div className="gridGallery">
        {this.renderList()}
        {this.renderPopup()}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    webp:state.webp
  }
}

export default inject("appStateStore")(observer(GridGallery));